import { render, staticRenderFns } from "./workflowForm.vue?vue&type=template&id=5c3c13a6&"
import script from "./workflowForm.vue?vue&type=script&lang=js&"
export * from "./workflowForm.vue?vue&type=script&lang=js&"
import style0 from "./workflowForm.vue?vue&type=style&index=0&id=5c3c13a6&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports